import React, { useState } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  Current_User,
  Pl_Comment_Modal_State,
  Pl_Comment_Warning_Modal_State,
  PursuitLeaderTableRowDataState,
  Refresh_Pl_Sidebar_Data,
  Is_Baddata_Available,
  Full_Page_Loading_State,
  System_Date_Time_State,
  Is_Opps_Bad_Data_Available_State,
} from '@recoil/recoil';
import '@organisms/modals/styles/plOpportunityNameModalStyles.css';
import { alertIcWarning24px } from '@ey-xd/motif-react/assets/icons';
import {
  MessageHeading,
  MessageParagraph,
  ModalHeaderContainer,
} from '@organisms/modals/styles/plOpportunityNameModal.styles';
import { IFRAME_EXIT_MODAL_REFRESH, OPPORTUNITY_ACCESS_NOTE } from '@constants/commonConstants';
import { retainCommitAndModifyOpportunity, isBadDataAvailable } from '@util/commonFunctions';
import { getOpportunitiesDetails } from '@services/pursuitLeaderServices';

const PlCommentModal = ({ id, urlSource }) => {
  const targetUrl = urlSource;

  // Use States
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [checkedCheckbox, setCheckbox] = useState(false); // eslint-disable-line no-unused-vars

  // Recoil States
  const [showPlIframeModalRecoil, setPlIframeModalRecoil] = useRecoilState(Pl_Comment_Modal_State); // This state is used to manipulate iframe modal from another component

  const [showPlInnerWarningModalRecoil, setPlInnerWarningModalRecoil] = useRecoilState(
    Pl_Comment_Warning_Modal_State,
  ); // This state is used to do not open modal if do not show again is clicked
  const setIsFullPageLoading = useSetRecoilState(Full_Page_Loading_State);

  const [refreshPLSidebarData, setRefreshPLSidebarData] = useRecoilState(Refresh_Pl_Sidebar_Data); // eslint-disable-line
  const [plRowData, setPlRowData] = useRecoilState(PursuitLeaderTableRowDataState);
  const currentUser = useRecoilValue(Current_User);
  const setIsBaddataFound = useSetRecoilState(Is_Baddata_Available);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const setIsOppsBadDataAvailable = useSetRecoilState(Is_Opps_Bad_Data_Available_State);
  const TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();

  const onPlCloseModal = () => {
    // Reset iframe operation flag when modal closes for super user
    localStorage.setItem('isIframeOperation', 'false');
    if (showPlInnerWarningModalRecoil) {
      setPlIframeModalRecoil(false);
    } else {
      setShowWarningModal(true); // Close warnig modal
    }
  };

  const onWarningCloseModal = () => {
    setShowWarningModal(false);
  };

  const onGoBackClick = () => {
    setShowWarningModal(false);
    // Comment below two lines, if checkbox should be keep selected for go back option
    setCheckbox(false);
    setPlInnerWarningModalRecoil(false);
  };

  const onExitOppsDetailsClick = async () => {
    // Reset iframe operation flag when modal closes for super user
    localStorage.setItem('isIframeOperation', 'false');
    setIsFullPageLoading(true);
    setPlIframeModalRecoil(false);
    setShowWarningModal(false);
    clearTimeout();

    // setTimeout(async () => {
    const getOpportunitiesDetailsAPI = await getOpportunitiesDetails(currentUser.email, TodaysDate);
    const newOpportunites = getOpportunitiesDetailsAPI?.opportunities;
    setIsOppsBadDataAvailable(getOpportunitiesDetailsAPI?.isBadDataAvailable);
    const badDataStatus = await isBadDataAvailable(newOpportunites);
    setIsBaddataFound(badDataStatus);
    sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(newOpportunites));

    const updateOpportunites = await retainCommitAndModifyOpportunity(plRowData, newOpportunites);
    setPlRowData(updateOpportunites);
    setRefreshPLSidebarData(true);
    // }, 7000);
  };

  return (
    <>
      {/* iFrame Modal */}
      <MotifModal
        show={showPlIframeModalRecoil}
        onClose={() => onPlCloseModal()}
        variant="default"
        size="xl"
        className="pl-opps-modal-container"
        // takeover= 'true'
      >
        <MotifModalHeader title="Close opportunity details modal">
          {IFRAME_EXIT_MODAL_REFRESH.TITLE}

          <div>
            <p style={{ marginTop: '8px', color: '#5a6268', fontSize: '15px' }}>
              <span style={{ fontWeight: 700, fontSize: '17px' }}>
                {OPPORTUNITY_ACCESS_NOTE.NOTE_TITLE}
              </span>{' '}
              {OPPORTUNITY_ACCESS_NOTE.ERROR_MESSAGE}{' '}
              <a
                href={`${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'blue', textDecoration: 'underline' }}
              >
                {OPPORTUNITY_ACCESS_NOTE.LINK_TEXT}
              </a>{' '}
              {OPPORTUNITY_ACCESS_NOTE.SIGNIN_MESSAGE}
            </p>
          </div>
        </MotifModalHeader>
        <MotifModalBody className="modal-body">
          <iframe src={targetUrl} className="iframe-container" title="PL comment modal"></iframe>
        </MotifModalBody>
      </MotifModal>

      {/* Warning Close Modal */}
      {showWarningModal ? (
        <MotifModal
          show={showPlIframeModalRecoil}
          onClose={() => onWarningCloseModal()}
          variant="alt"
          size="md"
          focusTrapOptions={{
            initialFocus: false,
          }}
        >
          <MotifModalHeader closeModalButton={true}>
            <ModalHeaderContainer>
              <MotifIcon className="modal-header-icon" src={alertIcWarning24px} />
              {IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION1}
            </ModalHeaderContainer>
          </MotifModalHeader>
          <MotifModalBody className="modal-body warning-modal-body">
            <MessageParagraph>{IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION2}</MessageParagraph>

            <MessageHeading>{IFRAME_EXIT_MODAL_REFRESH.GO_BACK}</MessageHeading>
            <MessageParagraph>{IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION3}</MessageParagraph>

            <MessageHeading>{IFRAME_EXIT_MODAL_REFRESH.EXIT_REFRESH}</MessageHeading>
            <MessageParagraph>{IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION4}</MessageParagraph>

            {/* Commented as per new requirement */}
            {/* <MotifFormField className="do-not-show-checkbox">
              <MotifCheckbox
                id="pl-warning-close-modal"
                value="do-not-show-again"
                name="do-not-show-again"
                checked={checkedCheckbox}
                onChange={(event) => onToggleCheckbox(event.target.checked)}
              >
                {WARNING_MESSAGES.do_not_show_again}
              </MotifCheckbox>
            </MotifFormField> */}
          </MotifModalBody>

          <MotifModalFooter>
            <MotifButton variant="warn" type="button" onClick={onGoBackClick}>
              {IFRAME_EXIT_MODAL_REFRESH.GO_BACK}
            </MotifButton>
            <MotifButton variant="secondary" type="button" onClick={onExitOppsDetailsClick}>
              {IFRAME_EXIT_MODAL_REFRESH.EXIT_REFRESH}
            </MotifButton>
          </MotifModalFooter>
        </MotifModal>
      ) : null}
    </>
  );
};

export default PlCommentModal;
